import React, { useState } from "react";
import { Box, Button, FormControlLabel, Checkbox } from "@mui/material";

interface MainBodyFilterPremierProps {
  onApplyFilters: (filterString: string) => void;
}

const MainBodyFilterPremier: React.FC<MainBodyFilterPremierProps> = ({
  onApplyFilters,
}) => {
  const [notActive, setNotActive] = useState(false);

  const handleApply = () => {
    // Формируем строку фильтров
    let filterString = "";
    filterString += `notactive=${notActive ? 1 : 0}`;

    // Можно добавлять другие фильтры сюда через &
    // filterString += `&otherFilter=${value}`;

    onApplyFilters(filterString);
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      p={2}
      mb={2}
      sx={{ backgroundColor: "#f5f5f5", borderRadius: 1 }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={notActive}
            onChange={(e) => setNotActive(e.target.checked)}
          />
        }
        label="Not Active"
      />
      <Button variant="contained" onClick={handleApply}>
        Сформировать
      </Button>
    </Box>
  );
};

export default MainBodyFilterPremier;
